<i18n lang="json">
{
  "zh-cn": {
    "title": "账户余额",
    "total_recharge_amount_usd": "累计充值金额(USD)",
    "total_recharge_count": "累计充值笔数(笔)",
    "pending_amount_usd": "待入账金额(USD)",
    "pending_count": "待入账笔数(笔)"
  },
  "en": {
    "title": "Account Balance",
    "total_recharge_amount_usd": "Total Recharge Amount (USD)",
    "total_recharge_count": "Total Recharge Count",
    "pending_amount_usd": "Pending Amount (USD)",
    "pending_count": "Pending Count"
  }
}
</i18n>

<script setup lang="ts">
import type { dashboardInfoAccountType } from '@/api/modules/index'
import useRechargeStore from '@/store/modules/recharge'
import { CountTo } from 'vue3-count-to'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  loading: {
    type: Boolean,
    required: true,
    default: true,
  },
  account: {
    type: Object as PropType<dashboardInfoAccountType>,
    required: true,
    default: () => ({
      balance: '0',
      recharge_sum: '0',
      recharge_count: 0,
      recharge_pending_sum: '0',
      recharge_pending_count: 0,
    }),
  },
})

const rechargeStore = useRechargeStore()

const { t } = useI18n()
</script>

<template>
  <FaPageMain
    v-loading="props.loading"
    class="m-0 mb-5 min-h-85 p-0 shadow-[0px_0px_16px_0px_rgba(0,0,0,0.03)]"
    main-class="p-4 flex-1 flex flex-col justify-between"
  >
    <p>
      <span class="font-size-5 c-[var(--el-color-primary-dark-6)] font-bold">{{ t('title') }}</span>
    </p>

    <div class="py-5 font-size-4 leading-7">
      <img class="inline-block w-4 rounded-5 align-middle" src="https://wallex2.oss-cn-hangzhou.aliyuncs.com/asset/images/flags/us.png">
      <span class="inline-block px-1 align-middle font-size-3 c-gray">USD</span>
      <CountTo
        class="align-middle font-size-6.5 font-bold"
        :start-val="0"
        :end-val="Number(props.account.balance)"
        :duration="2000"
        :decimals="2"
        separator=","
        prefix="$"
      />
      <RouterLink
        v-slot="{ navigate }"
        class="float-right"
        :to="{
          name: 'FundManageRecharge',
        }"
        custom
      >
        <el-button
          type="primary" @click="() => {
            rechargeStore.openRecharge = true
            navigate()
          }"
        >
          {{ t('recharge_now') }}
        </el-button>
      </RouterLink>
    </div>

    <el-row class="clear-both mt-3 rounded-3 bg-gray bg-opacity-5 p-4">
      <el-col :xl="13" :lg="13" :md="24" :sm="24" :xs="24">
        <p class="font-size-3.5 c-[var(--el-color-primary-dark-6)]">
          {{ t('total_recharge_amount_usd') }}
        </p>
        <CountTo
          class="font-size-5.5 font-bold"
          :start-val="0"
          :end-val="Number(props.account.recharge_sum)"
          :duration="2000"
          :decimals="2"
          separator=","
          prefix="$"
        />
      </el-col>
      <el-col :xl="11" :lg="11" :md="24" :sm="24" :xs="24">
        <p class="font-size-3.5 c-[var(--el-color-primary-dark-6)]">
          {{ t('total_recharge_count') }}
        </p>
        <CountTo
          class="font-size-5.5 font-bold"
          :start-val="0"
          :end-val="Number(props.account.recharge_count)"
          :duration="2000"
          :decimals="0"
          separator=","
        />
      </el-col>
    </el-row><el-row class="mt-3 rounded-3 bg-gray bg-opacity-5 p-4">
      <el-col :xl="13" :lg="13" :md="24" :sm="24" :xs="24">
        <p class="font-size-3.5 c-[#337BFF]">
          {{ t('pending_amount_usd') }}
        </p>
        <CountTo
          class="font-size-5.5 font-bold"
          :start-val="0"
          :end-val="Number(props.account.recharge_pending_sum)"
          :duration="2000"
          :decimals="2"
          separator=","
          prefix="$"
        />
      </el-col>
      <el-col :xl="11" :lg="11" :md="24" :sm="24" :xs="24">
        <p class="font-size-3.5 c-[#337BFF]">
          {{ t('pending_count') }}
        </p>
        <CountTo
          class="font-size-5.5 font-bold"
          :start-val="0"
          :end-val="Number(props.account.recharge_pending_count)"
          :duration="2000"
          :decimals="0"
          separator=","
        />
      </el-col>
    </el-row>
  </FaPageMain>
</template>

<style scoped>
/* 样式 */
</style>
